/*
 * Module for the Audit Trail index page
*/

rs.module("framework/content/audittrail/index",

    [
        "common/select-helper",
        "controls/data/grid"
    ],

    function (selectHelper, gridModule) {

        //
        // Initialize
        //
        function initialize(jsSelectors, lrsGridApi, backendUrls, searchValues, actionOptions, codeValues) {
            var filterForm = $.js(jsSelectors.filterForm);            
            var auditType = filterForm.js(jsSelectors.auditType);
            var action = filterForm.js(jsSelectors.action);
            var onlineFlag = filterForm.js(jsSelectors.onlineFlag);
            var actionSelectHelper = selectHelper.getHelper(action);
            var businessDomain = filterForm.js(jsSelectors.businessDomain);
            var businessDomainSelectHelper = selectHelper.getHelper(businessDomain);
            var domainTopic = filterForm.js(jsSelectors.domainTopic);
            var domainTopicSelectHelper = selectHelper.getHelper(domainTopic);
            var exportSelector = filterForm.js(jsSelectors.exportSelector);
            var includeRecordOwners = filterForm.js(jsSelectors.includeRecordOwners);
            var loadingSpinner = filterForm.js(jsSelectors.loadingSpinner);

            if (searchValues.searchToken) {
                loadingSpinner.show();
                var interval = setInterval(function () {
                    gridModule.update(
                        backendUrls.getGridData,
                        {
                            searchVersion: searchValues.searchVersion,
                            searchTopic: searchValues.searchTopic,
                            fromDate: searchValues.fromDate,
                            toDate: searchValues.toDate,
                            domain: searchValues.domain,
                            includeOwners: searchValues.includeOwners,
                            auditType: searchValues.auditType,
                            auditAction: searchValues.action,
                            includeImpersonators: searchValues.includeImpersonators,
                            user: searchValues.user,
                            searchToken: searchValues.searchToken,
                            accountKey: searchValues.accountKey,
                            accountPartyKey: searchValues.accountPartyKey,
                            employerKey: searchValues.employerKey,
                            personKey: searchValues.personKey,
                            ownerKey: searchValues.ownerKey
                        },

                        lrsGridApi.agGridApi,

                        function done(gridUpdate) {
                            if (!gridUpdate.context.resultsPending) {
                                clearInterval(interval);
                                loadingSpinner.hide();
                            }
                        }
                    );
                }, 2000);
            }

            auditType.change(function () {
                if (auditType.val() == codeValues.dataAudit) {
                    actionSelectHelper.replaceOptions(actionOptions.dataAuditOptions, { withBlank: true });
                    businessDomainSelectHelper.setDisabled(false);
                    domainTopicSelectHelper.setDisabled(false);
                    onlineFlag.prop('disabled', false)
                }
                if (auditType.val() == codeValues.userEventAudit) {
                    actionSelectHelper.replaceOptions(actionOptions.userEventAuditOptions, { withBlank: true });
                    businessDomainSelectHelper.setValue(null);
                    domainTopicSelectHelper.setValue(null);
                    businessDomainSelectHelper.setDisabled(true);
                    domainTopicSelectHelper.setDisabled(true);
                    onlineFlag.prop('disabled', true);
                    onlineFlag.prop('checked', false);
                }
            });

            businessDomain.change(function () {
                $.getJSON(
                    backendUrls.getDomainTopics,

                    { businessDomain: businessDomain.val(), searchVersion: searchValues.searchVersion }
                ).done(function (data) {
                    domainTopicSelectHelper.replaceOptions(data, { withBlank: true });

                });
            });

            exportSelector.change(function () {
                if (exportSelector.val() === 'true') {
                    includeRecordOwners.prop('disabled', false);
                }
                else {
                    includeRecordOwners.prop('disabled', true);
                    includeRecordOwners.prop('checked', false);
                }
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);